import { useTranslation } from "react-i18next";
import { cn } from "@/lib/cn";

export function Spinner({ className, size = 16 }: { className?: string; size?: number }) {
  const { t } = useTranslation("ui");
  return (
    <svg
      className={cn("animate-spin", className)}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      role="status"
      aria-label={t("spinner.loading")}
    >
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.25" strokeWidth="3" />
      <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}
